import React from 'react';
import { Link } from 'react-router-dom';
import {
    MapPinIcon,
    PhoneIcon,
    EnvelopeIcon
} from '@heroicons/react/24/outline';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const navigation = {
        company: [
            { name: 'Témoignages', href: '/testimonials' },
            { name: 'Services', href: '/services' },
            { name: 'Portfolio', href: '/portfolio' },
            { name: 'Blog', href: '/blog' },
        ],
        support: [
            { name: 'Contact', href: '/contact' },
            // { name: 'FAQ', href: '/faq' },
            { name: 'Emplois', href: '/jobs' },
            { name: 'Témoignages', href: '/testimonials' },
        ],
        legal: [
            { name: 'Politique de confidentialité', href: '/privacy' },
            { name: 'Conditions d\'utilisation', href: '/terms' },
        ],
        social: [
            {
                name: 'Facebook',
                href: 'https://facebook.com/kolabotech',
                icon: (props: React.ComponentProps<'svg'>) => (
                    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                        <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                    </svg>
                ),
            },
            {
                name: 'Twitter',
                href: 'https://twitter.com/kolabo_tech',
                icon: (props: React.ComponentProps<'svg'>) => (
                    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                ),
            },
            {
                name: 'LinkedIn',
                href: 'https://linkedin.com/company/kolabotech',
                icon: (props: React.ComponentProps<'svg'>) => (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>
                ),
            },
            {
                name: 'GitHub',
                href: 'https://github.com/kolabotech',
                icon: (props: React.ComponentProps<'svg'>) => (
                    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                        <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                    </svg>
                ),
            }
        ],
    };

    return (
        <footer className="bg-white dark:bg-gray-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Company Info */}
                    <div>
                        <h3 className="text-lg font-semibold text-blue-600 dark:text-blue-400 mb-4">
                            Kolabo Tech
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400 mb-4">
                            Solutions numériques innovantes pour propulser votre entreprise vers le futur.
                        </p>
                        <div className="flex space-x-4">
                            {navigation.social.map((item) => (
                                <a
                                    key={item.name}
                                    href={item.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
                                >
                                    <span className="sr-only">{item.name}</span>
                                    <item.icon className="h-6 w-6" aria-hidden="true" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Company Links */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                            Entreprise
                        </h3>
                        <ul className="space-y-2">
                            {navigation.company.map((item) => (
                                <li key={item.name}>
                                    <Link
                                        to={item.href}
                                        className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors duration-200"
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Support Links */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                            Support
                        </h3>
                        <ul className="space-y-2">
                            {navigation.support.map((item) => (
                                <li key={item.name}>
                                    <Link
                                        to={item.href}
                                        className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors duration-200"
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                            Contact
                        </h3>
                        <ul className="space-y-4">
                            <li className="flex items-start space-x-3">
                                <MapPinIcon className="h-6 w-6 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                                <span className="text-gray-600 dark:text-gray-400">
                                    Rue 6 J, Cap-Haïtien, Haïti
                                </span>
                            </li>
                            <li className="flex items-center">
                                <PhoneIcon className="h-5 w-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mr-3" />
                                <div className="flex items-center whitespace-nowrap">
                                    <a
                                        href="tel:+50933868124"
                                        className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors duration-200"
                                    >
                                        +509 3386-8124
                                    </a>
                                    <span className="text-gray-600 dark:text-gray-400 mx-2">/</span>
                                    <a
                                        href="tel:+50940128282"
                                        className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors duration-200"
                                    >
                                        +509 4012-8282
                                    </a>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3">
                                <EnvelopeIcon className="h-5 w-5 text-blue-600 dark:text-blue-400 flex-shrink-0" />
                                <a
                                    href="mailto:info@kolabotech.com"
                                    className="text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors duration-200"
                                >
                                    info@kolabotech.com
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-600 dark:text-gray-400 text-sm">
                            {currentYear} KolaboTech. Tous droits réservés.
                        </p>
                        <div className="mt-4 md:mt-0">
                            {/* <ul className="flex space-x-6">
                                {navigation.legal.map((item) => (
                                    <li key={item.name}>
                                        <Link
                                            to={item.href}
                                            className="text-sm text-gray-600 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400 transition-colors duration-200"
                                        >
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul> */}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;